import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { AuthService } from "src/app/shared/services/auth.service";
import { setUser } from "src/app/store/auth/auth.action";
import { IAppState } from "src/app/store/index.state";
import { showLayout } from "src/app/store/layout/layout.action";
import { UserSessionService } from "src/app/shared/services/user.session.service";
import { SessionStorageService } from "src/app/shared/services/session-storage.service";
import { environment } from "src/environments/environment";
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
  username!: string;
  password!: string;
  // showLoader$ = this.store.select(spinnerSelector);
  showLoader = false;
  showErrorMessage = false;
  errorMessage = "";
  isValid: boolean;
  isLMS: boolean = false;

  constructor(
    private store: Store<IAppState>,
    private authService: AuthService,
    private router: Router,
    private userSessionService: UserSessionService,
    private sessionStorageService: SessionStorageService,
    private toasterService: ToastrService,
  ) { }

  ngOnInit(): void {
    this.store.dispatch(showLayout({ value: false }));
    this.isLMS = !!(sessionStorage.getItem('app_id') && sessionStorage.getItem('app_context') && sessionStorage.getItem('app_type') && sessionStorage.getItem('JWTToken'));
  }
  /**
   *  @return
   * true if Administrator OR Content Manager
   */

  async onSubmit() {
    const payload = {
      username: this.username,
      password: this.password,
    };

    try {
      this.showLoader = true;
      let data: any = await this.authService
        .authenticate(payload.username, payload.password, true)
        .toPromise();

      if (data.success && data.isValidUser) {
        data['lmsResponse']['username'] = this.username;
        sessionStorage.clear();
        localStorage.clear();
        sessionStorage.setItem("organization_name", data.lmsResponse.affiliate_name);
        sessionStorage.setItem("token", data.lmsResponse.session_id);
        //sessionStorage.setItem("sessionId", data.session_id)
        sessionStorage.setItem("user", JSON.stringify(data.lmsResponse));
        this.store.dispatch(setUser({ user: data.lmsResponse }));
        this.store.dispatch(setUser({ user: data.lmsResponse }));

        sessionStorage.setItem('sessionId', data.sessionId);
        sessionStorage.setItem('userPermissions', data.userPermissions);
        localStorage.setItem('sessionId', data.sessionId);
        sessionStorage.setItem('isAdmin', JSON.stringify(data.isAdmin));
        this.router.navigateByUrl("/admin");
      } else {
        this.showErrorMessage = true;
        this.errorMessage = "Invalid username or password.";
      }
    } 
    catch (err: any) {
      console.log(err);
      this.toasterService.error(err.message)
      this.showErrorMessage = true;
      err.error.message 
        ?
          this.errorMessage = err.error.message
        :
          this.errorMessage = "Some error occurred, we are looking into it";
    } finally {
      this.showLoader = false;
    }
  }

  clearErrorMessage() {
    this.showErrorMessage = false;
  }
}